import { render, staticRenderFns } from "./Flota.vue?vue&type=template&id=06514312&scoped=true&"
import script from "./Flota.vue?vue&type=script&lang=js&"
export * from "./Flota.vue?vue&type=script&lang=js&"
import style0 from "./Flota.vue?vue&type=style&index=0&id=06514312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06514312",
  null
  
)

export default component.exports